/* ================================================================
   Cronduit Premium v4 · cronduit-premium.js
   Drop into: shopify-export/assets/cronduit-premium.js
   Load in layout/theme.liquid via:
   {{ 'cronduit-premium.js' | asset_url | script_tag }}
   ================================================================ */

(function() {
  'use strict';

  /* ── LOADER ──────────────────────────────────────────────────
     Dismisses after 1.9s. Add #cp-loader to your theme.liquid  */
  function initLoader() {
    const loader = document.getElementById('cp-loader');
    if (!loader) return;
    setTimeout(() => loader.classList.add('out'), 1900);
  }

  /* ── ANNOUNCE BAR DISMISS ───────────────────────────────────
     Dismisses .cp-announce and moves nav up                    */
  function initAnnounce() {
    const closeBtn = document.getElementById('cp-ann-close');
    const announce = document.querySelector('.cp-announce');
    const nav      = document.querySelector('.shopify-section-header, header, nav');
    if (!closeBtn || !announce) return;
    closeBtn.addEventListener('click', () => {
      announce.style.display = 'none';
      if (nav) nav.style.top = '0';
    });
  }

  /* ── CUSTOM CURSOR ──────────────────────────────────────────
     Dot = instant. Ring = lerp-lagged at 13% per frame        */
  function initCursor() {
    const dot  = document.getElementById('cp-cursor-dot');
    const ring = document.getElementById('cp-cursor-ring');
    if (!dot || !ring) return;
    // Skip on touch devices
    if (window.matchMedia('(hover: none)').matches) return;

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let rx = mx, ry = my;

    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top  = my + 'px';
    }, { passive: true });

    (function animRing() {
      rx += (mx - rx) * 0.13;
      ry += (my - ry) * 0.13;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animRing);
    })();

    // Expand ring on interactive elements
    document.querySelectorAll('a, button, .cp-tier, .cp-step-item').forEach(el => {
      el.addEventListener('mouseenter', () => ring.classList.add('big'));
      el.addEventListener('mouseleave', () => ring.classList.remove('big'));
    });
  }

  /* ── SCROLL PROGRESS BAR ─────────────────────────────────── */
  function initScrollProgress() {
    const bar = document.getElementById('cp-prog');
    if (!bar) return;
    window.addEventListener('scroll', () => {
      const doc = document.documentElement;
      const scrolled = doc.scrollTop;
      const total = doc.scrollHeight - doc.clientHeight;
      bar.style.width = (scrolled / total * 100) + '%';
    }, { passive: true });
  }

  /* ── HERO MOUSE PARALLAX ─────────────────────────────────── */
  function initParallax() {
    const bg = document.querySelector('.cp-hero-bg svg, .cp-hero-bg');
    if (!bg) return;
    document.addEventListener('mousemove', e => {
      const x = (e.clientX / window.innerWidth  - 0.5) * 18;
      const y = (e.clientY / window.innerHeight - 0.5) * 9;
      bg.style.transform  = `translate(${x}px, ${y}px) scale(1.06)`;
      bg.style.transition = 'transform .9s cubic-bezier(.16,1,.3,1)';
    }, { passive: true });
  }

  /* ── SCROLL REVEAL ───────────────────────────────────────── */
  function initReveals() {
    const all = Array.from(document.querySelectorAll('.cp-r'));
    if (!all.length) return;

    function inView(el) {
      const r = el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }

    // Add guard class AND reveal already-visible elements in the same sync block.
    // The browser won't render the opacity:0 state for above-fold elements this way.
    document.body.classList.add('cp-reveal-active');
    all.forEach(el => { if (inView(el)) el.classList.add('in'); });

    // Track remaining hidden elements and reveal on scroll
    const hidden = all.filter(el => !el.classList.contains('in'));
    if (!hidden.length) return;

    function onScroll() {
      let i = hidden.length;
      while (i--) {
        if (inView(hidden[i])) {
          hidden[i].classList.add('in');
          hidden.splice(i, 1);
        }
      }
      if (!hidden.length) {
        window.removeEventListener('scroll', onScroll);
        document.body.removeEventListener('scroll', onScroll);
      }
    }

    // Listen on both window and body to cover any scroll container
    window.addEventListener('scroll', onScroll, { passive: true });
    document.body.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── COUNTER-UP ──────────────────────────────────────────── */
  function countUp(el) {
    const target = parseInt(el.dataset.count, 10);
    if (!target) return;
    const duration = 1800;
    const inc = target / (duration / 16.7);
    let current = 0;
    const timer = setInterval(() => {
      current = Math.min(current + inc, target);
      el.textContent = Math.floor(current).toLocaleString();
      if (current >= target) clearInterval(timer);
    }, 16.7);
  }

  function initCounters() {
    const all = Array.from(document.querySelectorAll('.cp-readout, [data-count-trigger]'));
    if (!all.length) return;

    function checkCounters() {
      let i = all.length;
      while (i--) {
        const el = all[i];
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92 && r.bottom > 0) {
          el.querySelectorAll('[data-count]').forEach(countUp);
          all.splice(i, 1);
        }
      }
      if (!all.length) {
        window.removeEventListener('scroll', checkCounters);
        document.body.removeEventListener('scroll', checkCounters);
      }
    }

    checkCounters();
    window.addEventListener('scroll', checkCounters, { passive: true });
    document.body.addEventListener('scroll', checkCounters, { passive: true });
  }

  /* ── TYPEWRITER ──────────────────────────────────────────── */
  function initTypewriter(el, lines, opts) {
    opts = opts || {};
    const typeSpeed  = opts.typeSpeed  || 65;
    const eraseSpeed = opts.eraseSpeed || 38;
    const pauseCount = opts.pauseCount || 55;
    const cursorClass = opts.cursorClass || 'cp-cursor-blink';

    let li = 0, ci = 0, phase = 'type', pause = 0;

    function renderH(text, count, done) {
      // Apply accent class to specific words if needed
      let shown = text.slice(0, count);
      el.innerHTML = shown + `<span class="${cursorClass}">|</span>`;
    }

    function tick() {
      const line = lines[li];
      if (phase === 'pause') {
        pause++;
        if (pause > pauseCount) { phase = 'erase'; pause = 0; }
      } else if (phase === 'type') {
        ci++;
        if (ci >= line.length) phase = 'pause';
      } else {
        ci--;
        if (ci <= 0) {
          li = (li + 1) % lines.length;
          ci = 0;
          phase = 'type';
          // Glitch on reset
          el.classList.remove('glit');
          void el.offsetWidth; // force reflow
          el.classList.add('glit');
          setTimeout(() => el.classList.remove('glit'), 380);
        }
      }
      renderH(line, ci, phase === 'pause');
      const delay = phase === 'type' ? typeSpeed
        : phase === 'erase' ? eraseSpeed : 14;
      setTimeout(tick, delay);
    }
    tick();
  }

  /* ── 3D CARD TILT ────────────────────────────────────────── */
  function initTilt(selector, strength) {
    strength = strength || 8;
    document.querySelectorAll(selector || '.cp-tilt').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width  - 0.5;
        const y = (e.clientY - r.top)  / r.height - 0.5;
        card.style.transform  = `perspective(900px) rotateX(${-y * strength}deg) rotateY(${x * strength}deg)`;
        card.style.transition = 'transform .1s';
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform  = '';
        card.style.transition = 'transform .6s cubic-bezier(.16,1,.3,1)';
      });
    });
  }

  /* ── TESTIMONIAL MARQUEE ─────────────────────────────────── */
  function initMarquee() {
    // Handled entirely in CSS — no JS needed.
    // Just duplicate your .marquee-inner children in HTML.
    // The :hover { animation-play-state: paused } is in CSS.
  }

  /* ── FAQ ACCORDION ICONS ─────────────────────────────────── */
  function initFAQ() {
    document.querySelectorAll('details.cp-qi').forEach(d => {
      d.addEventListener('toggle', () => {
        const icon = d.querySelector('.cp-qi-icon');
        if (icon) icon.textContent = d.open ? '−' : '+';
      });
    });
  }

  /* ── NAV SCROLL BEHAVIOR ─────────────────────────────────── */
  function initNavScroll() {
    const nav = document.getElementById('cp-nav');
    if (!nav) return;
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ── INIT ALL ────────────────────────────────────────────── */
  function initAll() {
    initLoader();
    initAnnounce();
    initCursor();
    initScrollProgress();
    initParallax();
    initReveals();
    initCounters();
    initFAQ();
    initNavScroll();
    initTilt('.cp-tilt', 8);

    // Typewriter: auto-init if element exists
    const twEl = document.getElementById('cp-typewriter');
    if (twEl) {
      const lines = JSON.parse(twEl.dataset.lines || '[]');
      if (lines.length) initTypewriter(twEl, lines);
    }

    initV2Hero();
  }

  /* ── v2 PRODUCT HERO CARD ────────────────────────────────────
     3D mouse-tilt + click-to-lightbox. Hover-glow / shimmer / scan
     are CSS-only. Pairs with snippets/cronduit-v2-hero.liquid.
     ─────────────────────────────────────────────────────────────── */
  function initV2Hero() {
    if (matchMedia('(hover: none)').matches) {
      // touch device — skip tilt + lightbox icon, keep click-zoom
    } else {
      document.querySelectorAll('[data-cp-tilt]').forEach(card => {
        let raf = null;
        card.addEventListener('mousemove', e => {
          const r = card.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - 0.5;
          const y = (e.clientY - r.top) / r.height - 0.5;
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            card.classList.add('cp-tilting');
            card.style.transform = `perspective(1100px) rotateX(${-y * 6}deg) rotateY(${x * 6}deg)`;
          });
        });
        card.addEventListener('mouseleave', () => {
          card.classList.remove('cp-tilting');
          card.style.transform = '';
        });
      });
    }

    // Lightbox: click hero → enlarge full-screen
    let lb = null;
    document.querySelectorAll('[data-cp-lightbox]').forEach(host => {
      host.addEventListener('click', e => {
        const img = host.querySelector('img');
        if (!img) return;
        if (!lb) {
          lb = document.createElement('div');
          lb.className = 'cp-lightbox';
          lb.innerHTML = '<button class="cp-lb-close" aria-label="Close">×</button><img alt="">';
          document.body.appendChild(lb);
          const close = () => lb.classList.remove('cp-lb-open');
          lb.addEventListener('click', close);
          document.addEventListener('keydown', ev => { if (ev.key === 'Escape') close(); });
        }
        lb.querySelector('img').src = img.currentSrc || img.src;
        lb.querySelector('img').alt = img.alt || '';
        lb.classList.add('cp-lb-open');
      });
    });
  }

  // Guard against defer scripts running after DOMContentLoaded has fired
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ── PUBLIC API ──────────────────────────────────────────── */
  window.CronduitPremium = {
    countUp,
    initTypewriter,
    initTilt,
    initReveals,
    initCounters,
    initV2Hero,
  };

})();
